import type {
  Battle,
  CollabRequest,
  Notification,
  Song,
  TierInfo,
  User,
  Report,
} from '../types';

export const CURRENT_USER_ID = 'user-demo-1';

export const mockUsers: User[] = [
  {
    id: 'user-demo-1',
    username: 'KingMello',
    email: 'mello@iammuzik.app',
    role: 'ADMIN',
    tier: 'TIER_3',
    tierExpiresAt: '2026-12-31',
    createdAt: '2026-01-04T10:00:00Z',
    bio: 'Producer / artist from Kingsland, GA. Building real music, no shortcuts.',
    avatarColor: '#2454f5',
  },
  {
    id: 'user-2',
    username: 'LyraVox',
    email: 'lyra@iammuzik.app',
    role: 'USER',
    tier: 'FREE',
    createdAt: '2026-02-11T08:30:00Z',
    bio: 'Vocalist. Clean vibes only.',
    avatarColor: '#c9a227',
  },
  {
    id: 'user-3',
    username: 'BeatForge',
    email: 'forge@iammuzik.app',
    role: 'USER',
    tier: 'TIER_2',
    createdAt: '2026-03-02T14:10:00Z',
    bio: 'Hip-hop & R&B producer.',
    avatarColor: '#37b879',
  },
];

export const mockSongs: Song[] = [
  {
    id: 'song-1',
    ownerId: 'user-demo-1',
    ownerUsername: 'KingMello',
    title: 'Midnight Royal',
    genre: 'Hip-Hop',
    notes: 'Studio cut, mixed for the Wave.',
    lyrics: 'I came from the soil, royal in the night...',
    fileName: 'midnight-royal.mp3',
    coverColor: '#1747d1',
    durationLabel: '3:24',
    privacy: 'PUBLIC_APPROVED',
    contentRating: 'CLEAN',
    status: 'ACTIVE',
    createdAt: '2026-07-12T09:00:00Z',
    updatedAt: '2026-07-12T09:00:00Z',
    plays: 1240,
  },
  {
    id: 'song-2',
    ownerId: 'user-demo-1',
    ownerUsername: 'KingMello',
    title: 'Gold Crown (Demo)',
    genre: 'R&B',
    notes: 'Work in progress, private for now.',
    lyrics: '',
    fileName: 'gold-crown-demo.mp3',
    coverColor: '#c9a227',
    durationLabel: '2:51',
    privacy: 'PRIVATE',
    contentRating: 'CLEAN',
    status: 'DRAFT',
    createdAt: '2026-08-01T18:20:00Z',
    updatedAt: '2026-08-02T07:10:00Z',
    plays: 0,
  },
  {
    id: 'song-3',
    ownerId: 'user-demo-1',
    ownerUsername: 'KingMello',
    title: 'Raw Truth',
    genre: 'Hip-Hop',
    notes: 'Explicit version — kept private. A clean cut is needed for The Wave.',
    lyrics: '',
    fileName: 'raw-truth-explicit.mp3',
    coverColor: '#df3f3f',
    durationLabel: '4:02',
    privacy: 'PRIVATE',
    contentRating: 'EXPLICIT',
    status: 'ACTIVE',
    createdAt: '2026-08-05T12:00:00Z',
    updatedAt: '2026-08-05T12:00:00Z',
    plays: 0,
  },
  {
    id: 'song-4',
    ownerId: 'user-2',
    ownerUsername: 'LyraVox',
    title: 'Golden Mornings',
    genre: 'Gospel',
    notes: '',
    lyrics: '',
    fileName: 'golden-mornings.mp3',
    coverColor: '#f2d36c',
    durationLabel: '3:10',
    privacy: 'PUBLIC_APPROVED',
    contentRating: 'CLEAN',
    status: 'ACTIVE',
    createdAt: '2026-07-20T11:00:00Z',
    updatedAt: '2026-07-20T11:00:00Z',
    plays: 880,
  },
  {
    id: 'song-5',
    ownerId: 'user-3',
    ownerUsername: 'BeatForge',
    title: 'Forge Anthem',
    genre: 'Pop',
    notes: '',
    lyrics: '',
    fileName: 'forge-anthem.mp3',
    coverColor: '#37b879',
    durationLabel: '2:58',
    privacy: 'PUBLIC_APPROVED',
    contentRating: 'CLEAN',
    status: 'ACTIVE',
    createdAt: '2026-07-28T16:45:00Z',
    updatedAt: '2026-07-28T16:45:00Z',
    plays: 610,
  },
  {
    id: 'song-6',
    ownerId: 'user-2',
    ownerUsername: 'LyraVox',
    title: 'After Hours (Requested)',
    genre: 'R&B',
    notes: 'Submitted for Wave review.',
    lyrics: '',
    fileName: 'after-hours.mp3',
    coverColor: '#7a4dff',
    durationLabel: '3:40',
    privacy: 'PUBLIC_REQUESTED',
    contentRating: 'CLEAN',
    status: 'UNDER_REVIEW',
    createdAt: '2026-08-10T09:15:00Z',
    updatedAt: '2026-08-10T09:15:00Z',
    plays: 0,
  },
];

export const mockBattles: Battle[] = [
  {
    id: 'battle-1',
    title: 'Royal Blue Cypher — Vol. 1',
    genre: 'Hip-Hop',
    theme: 'Original bars, no samples',
    entryFeeCents: 5000,
    minimumVerifiedEntrants: 24,
    maximumEntrants: 32,
    status: 'SUBMISSIONS_OPEN',
    submissionsOpenAt: '2026-08-10T00:00:00Z',
    submissionsCloseAt: '2026-08-25T23:59:59Z',
    startsAt: '2026-08-28T20:00:00Z',
    endsAt: '2026-09-18T23:59:59Z',
    rules:
      'One eligible original track per entrant. Must fit Hip-Hop genre. Clean or explicit allowed in battle, but a clean version is required for any public promotion. 70% judge score / 30% verified audience vote.',
    prizeNote:
      '1st: 12 months free Tier 4 + Champion badge. 2nd: 6 months free Tier 4. 3rd: 3 months free Tier 4. No cash prizes.',
  },
  {
    id: 'battle-2',
    title: 'Gospel Glow Showdown',
    genre: 'Gospel',
    theme: 'Uplifting originals',
    entryFeeCents: 5000,
    minimumVerifiedEntrants: 24,
    maximumEntrants: 32,
    status: 'UPCOMING',
    submissionsOpenAt: '2026-09-01T00:00:00Z',
    submissionsCloseAt: '2026-09-15T23:59:59Z',
    startsAt: '2026-09-20T20:00:00Z',
    rules: 'Clean originals only. 70/30 judge/audience scoring.',
    prizeNote: '1st: 12 months Tier 4. 2nd: 6 months. 3rd: 3 months. No cash prizes.',
  },
];

export const mockNotifications: Notification[] = [
  {
    id: 'n-1',
    type: 'BATTLE_UPDATE',
    title: 'Royal Blue Cypher submissions are open',
    body: 'The Hip-Hop battle is accepting entries until Aug 25.',
    read: false,
    createdAt: '2026-08-12T08:00:00Z',
  },
  {
    id: 'n-2',
    type: 'APPROVAL',
    title: 'Midnight Royal approved for The Wave',
    body: 'Your clean track is now live on the public feed.',
    read: false,
    createdAt: '2026-08-09T14:30:00Z',
  },
  {
    id: 'n-3',
    type: 'PROMOTION',
    title: 'You are featured on the homepage',
    body: 'Midnight Royal is in the featured rotation this week.',
    read: true,
    createdAt: '2026-08-06T10:00:00Z',
  },
];

export const mockCollabs: CollabRequest[] = [
  {
    id: 'c-1',
    title: 'Need a clean vocalist for an R&B hook',
    role: 'VOCALIST',
    description:
      'I have an instrumental. Looking for someone to write and record their own original hook. No AI lyrics — you write your own.',
    authorUsername: 'BeatForge',
    status: 'OPEN',
    createdAt: '2026-08-09T09:00:00Z',
  },
  {
    id: 'c-2',
    title: 'Producer wanted for a gospel track',
    role: 'PRODUCER',
    description: 'I have lyrics and a vocal recording. Need production around my vocal.',
    authorUsername: 'LyraVox',
    status: 'OPEN',
    createdAt: '2026-08-11T12:00:00Z',
  },
];

export const mockReports: Report[] = [
  {
    id: 'r-1',
    target: 'song-6 — After Hours (Requested)',
    reason: 'Reported for possible unclean language pending review.',
    status: 'OPEN',
    createdAt: '2026-08-11T15:00:00Z',
  },
];

export const tierInfo: TierInfo[] = [
  {
    id: 'FREE',
    name: 'Free Contract',
    price: '$0',
    accent: '#ababab',
    tagline: 'Start your journey. Upload, build your library, browse The Wave.',
    features: [
      'Create an account',
      '2 uploads per month',
      'Private library',
      'Browse The Wave',
      'Listen to battles (no voting)',
    ],
    limits: { uploads: '2 / month', storage: '250 MB', battles: 'Listen only, no vote', collabs: 'Browse only' },
  },
  {
    id: 'TIER_1',
    name: 'Contract 1',
    price: '$9.99',
    accent: '#2454f5',
    tagline: 'Entry-level paid plan for active creators.',
    features: [
      'Everything in Free',
      '10 uploads per month',
      '1 GB storage',
      'Listen to battles (no voting yet)',
      'No battle entries',
    ],
    limits: { uploads: '10 / month', storage: '1 GB', battles: 'Listen only, no vote', collabs: 'Browse only' },
  },
  {
    id: 'TIER_2',
    name: 'Contract 2',
    price: '$19.99',
    accent: '#1747d1',
    tagline: 'For creators who post, collaborate, and vote.',
    features: [
      'Everything in Contract 1',
      '15 uploads per month',
      '5 GB storage',
      'Can vote in battles',
      'Accept collab requests from Contract 3 & 4',
      'Post availability (3 active collab posts)',
    ],
    limits: { uploads: '15 / month', storage: '5 GB', battles: 'Vote only, no entries', collabs: '3 active posts' },
  },
  {
    id: 'TIER_3',
    name: 'Contract 3',
    price: '$39.99',
    accent: '#c9a227',
    tagline: 'Serious creators: battles, AI tools, and outreach.',
    features: [
      'Everything in Contract 2',
      '25 uploads per month',
      '20 GB storage',
      'Battle entries: 2 songs/category, up to 2 categories',
      'AI instrumental + AI voice generation',
      'AI promo video demo / trailer (10–15s)',
      'Reach out to any artist to collab (10 requests, 5 active)',
    ],
    limits: { uploads: '25 / month', storage: '20 GB', battles: '2 songs × 2 categories', collabs: '10 requests, 5 active' },
  },
  {
    id: 'TIER_4',
    name: 'Contract 4 (Golden)',
    price: '$79.99',
    accent: '#f2d36c',
    tagline: 'VIP / Golden contract. Max storage, AI videos, and 5 battle categories.',
    features: [
      'Everything in Contract 3',
      '50 uploads per month',
      '100 GB storage',
      'Multiple battle entries, up to 5 categories',
      'Full AI music videos (1 every 60 days)',
      'AI promo video demo / trailer',
      'Unlimited collabs (10 active posts)',
    ],
    limits: { uploads: '50 / month', storage: '100 GB', battles: 'Up to 5 categories', collabs: 'Unlimited, 10 active' },
  },
];

export const GENRES: string[] = [
  'Hip-Hop',
  'R&B',
  'Gospel',
  'Pop',
  'Country',
  'Rock & Roll',
  'Reggae',
  'Rap',
  'Soul',
  'Other',
];

/** Moods available on the Studio / instrumental request. */
export const MOODS: string[] = [
  'Energetic',
  'Chill',
  'Dark',
  'Uplifting',
  'Aggressive',
  'Romantic',
  'Sad',
  'Party',
  'Spiritual',
  'Triumphant',
];

/**
 * Battle genres — the ONLY genres IAMMUZIK promotes in battles.
 * (You said 7 but named 6; tell us the 7th if there is one.)
 */
export const BATTLE_GENRES: string[] = [
  'Gospel',
  'Hip-Hop',
  'Pop',
  'Country',
  'Rock & Roll',
  'Reggae',
];

/**
 * Battle entry pricing.
 *  - First category entry: $50 (includes 1 song)
 *  - Each additional category: $30 (includes 1 song each)
 *  - Each additional song within a category: $10
 */
export const BATTLE_PRICING = {
  firstCategoryCents: 5000,
  additionalCategoryCents: 3000,
  additionalSongCents: 1000,
} as const;

/**
 * Compute the battle entry total in cents.
 * categories: array of how many songs the creator enters in each category.
 * Example: [2, 2] = 2 categories with 2 songs each = $50 + $30 + $10 + $10 = $100
 */
export function calcBattleTotalCents(songsPerCategory: number[]): number {
  if (songsPerCategory.length === 0) return 0;
  const firstCategory = BATTLE_PRICING.firstCategoryCents;
  const extraCategories = (songsPerCategory.length - 1) * BATTLE_PRICING.additionalCategoryCents;
  const extraSongs = songsPerCategory.reduce(
    (sum, songs) => sum + Math.max(0, songs - 1) * BATTLE_PRICING.additionalSongCents,
    0,
  );
  return firstCategory + extraCategories + extraSongs;
}
